import { Vue } from 'vue-property-decorator';
import { IIssue } from '@/lib/interfaces';

/**
 *
 * @param oldIssue задача, которую нужно обновить
 * @param newIssue задача с полями, которые нужно обновить
 */
export function updateAllIssue(
  oldIssue: IIssue, newIssue: IIssue,
) {
  Object.keys(newIssue).forEach((key) => {
    Vue.set(oldIssue, key, newIssue[key]);
  });
}

export function pushOrDeleteIssue(issues: IIssue[], newIssue: IIssue, isPush: boolean) {
  /** Найденная задача */
  let findIssue: IIssue | undefined;
  /** Индекс найденной задачи */
  let index: number | undefined;
  for (let i = 0; i < issues.length; i++) {
    if (issues[i]._id === newIssue._id) {
      findIssue = issues[i];
      index = i;
      break;
    }
  }
  //
  if (isPush) {
    if (!findIssue) {
      issues.push(newIssue);
    } else {
      updateAllIssue(findIssue, newIssue);
    }
  } else {
    if (findIssue) {
      issues.splice(index!, 1);
    }
  }
}
